import { trackEvent } from '../../../utils/appBridge'
import { EventNames } from '../../../types/misc.types'

export const TaxHarvestingScreenName = {
  Summary: 'Tax Harvesting Summary',
  Plan: 'Tax Harvesting Plan',
  Withdrawals: 'Tax Harvesting Withdrawals',
  Recommendation: 'Tax Harvesting Recommendation',
  Footer: 'Tax Harvesting',
  LtcgTaxLiability: 'LTCG Tax Liability',
  StcgTaxLiability: 'STCG Tax Liability',
  IncomeSlabSelection: 'Income Slab Selection',
  TaxationRules: 'Taxation Rules'
} as const

export const TaxHarvestingBottomSheetName = {
  LtcgSummary: 'LTCG Summary',
  LtcgTaxLiability: 'LTCG Tax Liability',
  StcgSummary: 'STCG Summary',
  StcgTaxLiability: 'STCG Tax Liability',
  IncomeSlabSelection: 'Income Slab Selection',
  RealisedStcl: 'Remaining STCL',
  ExemptionLimit: 'Exemption Limit',
  ImportantNote: 'Important Note',
  TaxationRules: 'Taxation Rules',
  TaxGrandfatheringRule: 'Tax Grandfathering Rule',
  HowGainsHarvestingWorks: 'How Gains Harvesting Works',
  HowLossBookingSavesTax: 'How Loss Booking Saves Tax',
  ElssAlternatives: 'ELSS Alternatives',
  HowToPayAdvanceTax: 'How To Pay Advance Tax',
  KnowMoreAdvanceTax: 'Know More Advance Tax'
} as const

export const TaxHarvestingEventId = {
  Back: 'back',
  ViewWithdrawals: 'view_withdrawals',
  LtcgPlanCard: 'ltcg_plan_card',
  StcgPlanCard: 'stcg_plan_card',
  LtcgSummary: 'ltcg_summary',
  LtcgTaxLiability: 'ltcg_tax_liability',
  StcgSummary: 'stcg_summary',
  StcgTaxLiability: 'stcg_tax_liability',
  PlanTab: 'plan_tab',
  ExemptionUsedInfo: 'exemption_used_info',
  RealisedStclInfo: 'realised_stcl_info',
  FilterChip: 'filter_chip',
  NetRealisedLtcg: 'net_realised_ltcg',
  NetRealisedStcg: 'net_realised_stcg',
  HowGainsHarvestingWorks: 'how_gains_harvesting_works',
  ViewAllGainsFunds: 'view_all_gains_funds',
  GainsFundCard: 'gains_fund_card',
  UnlockEliteOverlay: 'unlock_elite_overlay',
  ImportantNote: 'important_note',
  TaxationRules: 'taxation_rules',
  FaqAccordion: 'faq_accordion',
  UnlockEliteCta: 'unlock_elite_cta',
  HowLossBookingSavesTax: 'how_loss_booking_saves_tax',
  TaxSavingsFundCard: 'tax_savings_fund_card',
  ViewAllTaxSavingsFunds: 'view_all_tax_savings_funds',
  ReinvestFundCard: 'reinvest_fund_card',
  ElssViewAlternatives: 'elss_view_alternatives',
  FundSummaryCard: 'fund_summary_card',
  IncomeSlabEdit: 'income_slab_edit',
  SlabOption: 'slab_option',
  GrandfatheringRule: 'grandfathering_rule'
} as const

export const TaxHarvestingButtonLabel = {
  Back: 'Back',
  UnlockPlanWithElite: 'Unlock plan with Elite'
} as const

export function trackTaxHarvestingScreenLoaded(screen: string): void {
  trackEvent({
    eventName: EventNames.ScreenLoaded,
    payload: { ScreenName: screen }
  })
}

export function trackTaxHarvestingBottomSheetLoaded(bottomSheetName: string): void {
  trackEvent({
    eventName: EventNames.BottomSheetLoad,
    payload: { bottomSheetName }
  })
}

type UserClickedPayload = {
  screen: string
  eventId: string
  buttonLabel?: string
  fundIsin?: string
}

export function trackTaxHarvestingUserClicked(payload: UserClickedPayload): void {
  trackEvent({
    eventName: EventNames.UserClicked,
    payload: {
      ScreenName: payload.screen,
      eventId: payload.eventId,
      ...(payload.buttonLabel != null && { buttonLabel: payload.buttonLabel }),
      ...(payload.fundIsin != null && { fundIsin: payload.fundIsin })
    }
  })
}

type ButtonTapPayload = {
  screen: string
  eventId: string
  buttonLabel?: string
}

export function trackTaxHarvestingButtonTap(payload: ButtonTapPayload): void {
  trackEvent({
    eventName: EventNames.ButtonTap,
    payload: {
      ScreenName: payload.screen,
      eventId: payload.eventId,
      ...(payload.buttonLabel != null && { buttonLabel: payload.buttonLabel })
    }
  })
}
